import { AxiosResponse } from 'axios';
import { ICreditCardTransaction } from 'shared/models/transaction';
import { apiV2 } from './http';

export function load(
  orderId: number,
): Promise<AxiosResponse<ICreditCardTransaction[]>> {
  return apiV2.get<ICreditCardTransaction[]>(`pagarme/transactions/${orderId}`);
}
